import { render, staticRenderFns } from "./CreateApplication.vue?vue&type=template&id=32b4a406&scoped=true&"
import script from "./CreateApplication.vue?vue&type=script&lang=js&"
export * from "./CreateApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4a406",
  null
  
)

export default component.exports